<template>
  <div class="login-page">
    <app-navbar></app-navbar>
    <div class="wrapper wrapper-full-page">
      <div class="full-page login-page section-image">
        <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple" -->
        <div class="content">
          <div class="container">
            <div class="col-lg-4 col-md-6 ml-auto mr-auto">
              <form @submit.prevent="login">
                  <card type="login">
                    <h3 slot="header" class="header text-center">{{$t('Welcome')}}</h3>

                    <fg-input v-model="form.username"
                              v-validate="validations.username"
                              :error="getError('username')"
                              name="username"
                              autocomplete="username"
                              autocorrect="off"
                              autocapitalize="none"
                              addon-left-icon="nc-icon nc-single-02"
                              :placeholder="$t('Username')"/>

                    <fg-input v-model="form.password"
                              input-classes="input-with-right-icon"
                              addon-left-icon="nc-icon nc-key-25"
                              v-validate="validations.password"
                              :info="$t('note upper and lower case')"
                              :error="getError('password')"
                              name="password"
                              autocomplete="current-password"
                              :placeholder="$t('Password')"
                              :type="isPasswordVisible ? 'text' : 'password'">
                      <template slot="addonRight">
                        <button type="button" class="btn input-group-append btn-neutral btn-icon-right" @click="isPasswordVisible = !isPasswordVisible">
                          <span class="input-group-text icon-right">
                            <i v-if="isPasswordVisible" class="fa fa-eye fa-icon-width"/>
                            <i v-else class="fa fa-eye-slash fa-icon-width"/>
                          </span>
                        </button>
                      </template>
                    </fg-input>

                    <br>

                    <p-button native-type="submit" slot="footer" type="primary" size="md" round block class="mb-3">Login</p-button>

                    <router-link :to="{ name: 'PasswordReset'}" tag="a">
                      {{ $t('Forgot password') }}?
                    </router-link>
                  </card>
              </form>
            </div>
          </div>
        </div>
        <app-footer></app-footer>
        <div class="full-page-background" style="background-image: url(/static/img/sidebar.jpg) "></div>
      </div>
    </div>
  </div>
</template>
<script>
  import { Card, Button } from 'src/components/UIComponents';
  import AppNavbar from './Layout/AppNavbar'
  import AppFooter from './Layout/AppFooter'

  export default {
    components: {
      Card,
      AppNavbar,
      AppFooter,
      [Button.name]: Button
    },
    methods: {
      toggleNavbar() {
        document.body.classList.toggle('nav-open')
      },
      closeMenu() {
        document.body.classList.remove('nav-open')
        document.body.classList.remove('off-canvas-sidebar')
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      async login() {
        const isValid = await this.$validator.validateAll()
        if (!isValid) {
          return
        }

        try {
          await this.$auth.authenticate(this.form.username, this.form.password)
          this.$router.push('/')
        } catch (e) {
          this.$notify({ type: 'danger', title: this.$t('Login Error'), message: e.message })
        }
      }
    },
    data() {
      return {
        form: {
          username: '',
          password: ''
        },
        validations: {
          username: {
            required: true,
            // email: true
          },
          password: {
            required: true,
            min: 5
          }
        },
        isPasswordVisible: false
      }
    },
    beforeDestroy() {
      this.closeMenu()
    }
  }
</script>
<style lang="scss">
  .input-group-prepend .input-group-text {
    padding: 10px !important;
  }
  .input-group-append .input-group-text {
    padding: 10px 8px 10px 8px !important;
  }
  .btn-icon-right {
    z-index: -1;
    padding: 0 !important;
  }
  .icon-right {
    z-index: 1;
    border-bottom-left-radius: 0 !important;
    border-top-left-radius: 0 !important;
  }
  .input-with-right-icon {
    border-right: 0 none !important;
    border-bottom-right-radius: 0 !important;
    border-top-right-radius: 0 !important;
  }
  .fa-icon-width {
    width: 20px !important;
   }
</style>
